import React from 'react';
import { Stat } from '../../models/interfaces/Stat';
import PlayerView from '../players/PlayerView';
import { Row, Col } from 'react-bootstrap';

interface Props {
    stat: Stat;
}

function timestampString(timestamp) {
    const format = (val) => `0${Math.floor(val)}`.slice(-2);
    const minutes = (timestamp % 3600) / 60;

    return [minutes, timestamp % 60].map(format).join(':');
}

export default function StatView({ stat }: Props) {
    const player = stat.player;
    return (
        <>
            {/* small screen layout */}
            <Row className="justify-content-between">
                <Col xs="auto" className="d-sm-none align-items-center text-left">
                    <Row>
                        <Col>
                            <strong>{stat.displayName}</strong>
                        </Col>
                    </Row>
                    <Row>
                        <Col>{timestampString(stat.timestamp)}</Col>
                    </Row>
                </Col>
                <Col xs="auto" className="d-sm-none align-items-center text-right">
                    <Row>
                        <Col>{stat.team ? stat.team.name : 'Table' }</Col>
                    </Row>
                    <Row>
                        {player && (
                            <Col>
                                <PlayerView player={player} />
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
            {/* large screen layout */}
            <Row className="justify-content-center">
                <Col sm={4} className="d-none d-sm-block align-items-center text-center">
                    <Row>
                        <Col>
                            {/** Figure out ui for table work records */}
                            { ((stat.team && stat.match.lightCapTeam.id === stat.team.id) || !!!stat.team) && (
                                <>
                                    <strong>{stat.displayName}</strong>
                                    <span> - {stat.team ? stat.team.name : 'Table' }</span>
                                </>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        {player && (
                            <Col>
                                {(stat.team && stat.match.lightCapTeam.id === stat.team.id) && (
                                    <PlayerView player={player} />
                                )}
                            </Col>
                        )}
                    </Row>
                </Col>
                <Col sm="auto" className="d-none d-sm-block align-items-center text-center">
                    {/* height take up 100% of available and move items to center */}
                    <Row className="h-100 align-items-center">
                        <Col style={{ background: 'white' }}>{timestampString(stat.timestamp)}</Col>
                    </Row>
                </Col>
                <Col sm={4} className="d-none d-sm-block align-items-center text-center">
                    <Row>
                        <Col>
                            {(stat.team && stat.match.lightCapTeam.id !== stat.team.id) && (
                                <>
                                    <strong>{stat.displayName}</strong>
                                    <span> - {stat.team.name}</span>
                                </>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        {player && (
                            <Col>
                                {(stat.team && stat.match.lightCapTeam.id !== stat.team.id) && (
                                    <PlayerView player={player} />
                                )}
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
        </>
    );
}
